import { isArray, isObject } from '@dimjs/lang';
import type { TPlainObject } from '@flatbiz/utils';
import { localStorageCache, sessionStorageCache } from '@flatbiz/utils';

export const filterCache = {
  set: (cacheKey: string, filterCondition: TPlainObject) => {
    const value = filterCache.get(cacheKey);
    const mergeParams = {
      ...value,
      ...filterCondition,
    };
    sessionStorageCache.set(`easy_tab_filter_${cacheKey}`, mergeParams);
    return mergeParams as TPlainObject;
  },
  get: (cacheKey: string) => {
    const value = sessionStorageCache.get(
      `easy_tab_filter_${cacheKey}`
    ) as TPlainObject;
    return isObject(value) ? value : {};
  },
  remove: (cacheKey: string) => {
    sessionStorageCache.remove(`easy_tab_filter_${cacheKey}`);
  },
};

export const firstQueryCache = {
  set: (cacheKey: string, flag: boolean) => {
    sessionStorageCache.set(`easy_tab_firstQuery_${cacheKey}`, { value: flag });
  },
  get: (cacheKey: string) => {
    const value = sessionStorageCache.get(
      `easy_tab_firstQuery_${cacheKey}`
    )?.value;
    return value === false ? false : true;
  },
  remove: (cacheKey: string) => {
    sessionStorageCache.remove(`easy_tab_firstQuery_${cacheKey}`);
  },
};

export const columnFoldCache = {
  set: (cacheKey: string, value: string[]) => {
    localStorageCache.set(`easy_tab_columnFold_${cacheKey}`, { value });
  },
  get: (cacheKey: string) => {
    const value = localStorageCache.get(
      `easy_tab_columnFold_${cacheKey}`
    )?.value;
    return isArray(value) ? (value as string[]) : [];
  },
  remove: (cacheKey: string) => {
    localStorageCache.remove(`easy_tab_columnFold_${cacheKey}`);
  },
};
